module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('Social_Comments', {
		configure: function(options) {
			this.registerOptions('', {
				'showComments': false,
				'template': 'social_comments_block',
				'embed.container': '.reviews',
				'methods.load': 'social.comments.count',
				'methods.loadComments': 'social.comments.load',
				'methods.delete': 'social.comments.delete',
				'methods.post': 'social.comments.post',
				'handleDom.toggleForm': {
					event: 'click',
					target: '.toggleForm',
					callback: 'toggleHandler'
				},
				'handleDom.delete': {
					event: 'click',
					target: '.comment-delete',
					targetWidget: '.Grid #list',
					callback: 'deleteCommentHandler'
				}//,
				//'widgetGroupInfo.workers.manualActivation': 1
			}, false, 'comments.js');

			this.registerOptions('.Grid', {
				'list.tpl.row': 'social_comment',
				'list.container': '.reviews-list',
				'template': 'social_comments_grid',
				'container': '._reviews',
				'externalLoad': true
			}, false, 'comments.js');


			this.registerOptions('~#form', {
				'formElements.comment.element': '[name=comment]',
				'submit.target': '.add-review',
				'submit.event': 'submit'
			});


			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('.Social_Comments_Form', fox.mergeRecursive({
				'template': 'social_comments_addform',
				'embed.container': '.addreview-container',
			}, this.getOption('formOptions')), false, 'comments.js');
		
			this.callParent('init', arguments);
		},

		embedding: function() {
			this.element = [];
			var containers = fox.dom.select(this.requireOption('embed.container'), this.visualParent.element);
			fox.each(containers, function(container) {
				this.currentTargetId = container.getAttribute('data-target-id');
				this._render(true);
				this.embedToDom(container, this.fragment);
			}, this);
			this._rendered = false;
		},

		getDlForGrid: function (indx) {
			var dl = this.wom1(['#gridDl', indx].join('_'));

			if (!dl) {
				dl = this.embedWidget(['gridDl', indx].join('_'), 'Datalayer', {
						method: this.requireOption('methods.loadComments'),
						limit: this.getOption('dlLimit') || 10
				});

				dl.run();
			}

			return dl;
		},

		prepareData: function(data) {
			data = this.callParent('prepareData', arguments);
			var i = 0;
			this.consist = {};
			fox.each(data, function(data, id) {
				this.consist[id] = i;
				var grid, form, dl;
				if (!(grid = this.getEmbeddedWidget('grid_' + i))) {
					grid = this.embedWidget('grid_' + i, 'Grid', {
						dl: this.getDlForGrid(i)
					});

					grid.run();
				}

				grid.dl.setTransitParameter('targetId', id);
				
				if (this.getOption('subject')) {
					grid.dl.setTransitParameter('subject', this.getOption('subject'));
				}

				if (this.getOption('skipParentId')) {
					grid.dl.setTransitParameter('skipParentId', this.getOption('skipParentId'));
				}

				grid.dl.clearCollection();

				if (this.getOption('showComments')) {
					this.loadComments(id);
				}
				
				if (!(form = this.getEmbeddedWidget('form_' + i))) {
					form = this.embedWidget('form_' + i, 'Social_Comments_Form');
					form.run();
				}
				form.setOption('targetId', id);
				
				i++;
			}, this);
			return data;
		},

		toggleHandler: function(elt) {
			var targetId = elt.getAttribute('data-target-id');
			this.loadComments(targetId);

			var el = fox.dom.selectFirst('.reviews-actions-block', this.element);

			if (this.data[targetId].show) {
				fox.dom.removeClass('show-reviews', el);
				this.data[targetId].show = 0;
			} else {
				this.data[targetId].show = 1;
				fox.dom.addClass('show-reviews', el);
			}
		},

		deleteCommentHandler: function(elt) {
			var targetId = elt.getAttribute('data-target-id');
			var id = elt.getAttribute('data-iteration');
			this.deleteComment(targetId, id);
		},

		deleteComment: function(targetId, id) {
			var dl = this.requireEmbeddedWidget('grid_' + this.consist[targetId]).dl;
			var row = dl.extractObjectByIndex(id - 1);
			this.data[targetId].total = this.data[targetId].total && (this.data[targetId].total - 1);
			this.render();

			if (row.id) {
				this.getApi('delete').method(this.requireOption('methods.delete')).send(
					{targetId: targetId, id: row.id, isHidePreloader: true}, false
				);
			} else {
				this.getApi('delete').method(this.requireOption('methods.delete')).send(
					{targetId: targetId, obj: JSON.stringify(row), isHidePreloader: true}, false
				);
			}
		},

		addComment: function(obj) {
			if(!fox.trim(obj.comment).length) {
				$('textarea').addClass('warning');
				return;
			}
			$('textarea').removeClass('warning');
			var dl = this.requireEmbeddedWidget('grid_' + this.consist[obj.targetId]).dl;
			var collectionToArray = dl.setCollection(fox.toArray(dl.getCollection()));
			dl.addObject(fox.clone(obj, true), {top: true});
			this.data[obj.targetId].total = this.data[obj.targetId].total + 1;
			this.render();

			var apiData = {
				targetId: obj.targetId,
				comment: window.encodeURIComponent(this.changeInalidValue(obj.comment)),
				isHidePreloader: true
			};

			if (this.getOption('subject')) {
				apiData.subject = this.getOption('subject');
			}

			return this.getApi('post', {sendTimezone: true, httpMethod: 'post'}).send(apiData);
		},

		loadComments: function(targetId) {
			this.requireEmbeddedWidget('grid_' + this.consist[targetId]).dl.load(true);
		},
		changeInalidValue: function (params) {
			var regExps = /<\s*[^>]*>/g;
			var entities = {'<': '', '>': ''};
			if(regExps.test(params)){
				params = params.replace(/[<>]/g, function (s) {return entities[s];});
			}
			return 	params;
		},

	}, 'Social_Activity');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/social/comments.js
// module id = 475
// module chunks = 4